interface FireSolidIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const FireSolidIcon = ({ color = 'currentColor', size = '20', className, ...props }: FireSolidIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8028 1.9047C10.7013 1.76862 10.5489 1.67967 10.3805 1.6583C10.2121 1.63692 10.0422 1.68497 9.90995 1.79138C8.35146 3.0454 7.2645 4.86468 6.96102 6.93852C6.41387 6.54189 5.93333 6.05864 5.53966 5.50889C5.43137 5.35765 5.26133 5.26251 5.07579 5.24933C4.89025 5.23615 4.70847 5.3063 4.57989 5.44071C3.29206 6.78689 2.5 8.6139 2.5 10.6246C2.5 14.7667 5.85786 18.1246 10 18.1246C14.1421 18.1246 17.5 14.7667 17.5 10.6246C17.5 7.57384 15.6786 4.94987 13.0665 3.77826C12.1422 3.32701 11.3789 2.67724 10.8028 1.9047ZM13.125 11.8749C13.125 13.6008 11.7259 14.9999 10 14.9999C8.27411 14.9999 6.875 13.6008 6.875 11.8749C6.875 11.5338 6.92965 11.2055 7.03068 10.8981C7.55441 11.2853 8.15641 11.5727 8.80859 11.7321C8.98849 10.5648 9.57214 9.53067 10.4124 8.77689C11.9434 8.97872 13.125 10.2888 13.125 11.8749Z"
      fill={color}
    />
  </svg>
);
